export default function ComparisonChecklist() {
  const checklistItems = [
    {
      category: 'Credentials & Insurance',
      items: [
        'Valid business license',
        'General liability insurance',
        'Workers compensation coverage',
        'Background check verification'
      ]
    },
    {
      category: 'Skills & Experience',
      items: [
        'Years of handyman experience',
        'Range of services offered',
        'Specialized skills and certifications',
        'Portfolio of completed projects'
      ]
    },
    {
      category: 'Pricing & Availability',
      items: [
        'Clear hourly or project rates',
        'Written estimates provided',
        'Flexible scheduling options',
        'Emergency service availability'
      ]
    },
    {
      category: 'Reviews & Reputation',
      items: [
        'Online reviews and ratings',
        'Customer testimonials',
        'References from past clients',
        'Professional communication'
      ]
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-emerald-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Handyman Service Comparison Checklist
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Use this checklist to evaluate and compare handyman services before hiring.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {checklistItems.map((section, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg border border-emerald-100"
            >
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 flex items-center justify-center bg-emerald-600 text-white rounded-lg">
                  <i className="ri-checkbox-circle-line text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">
                  {section.category}
                </h3>
              </div>
              <ul className="space-y-4">
                {section.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <i className="ri-check-line text-emerald-600 text-xl mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700 leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-emerald-600 rounded-2xl p-8 text-center text-white">
          <h3 className="text-2xl font-bold mb-4">
            Ready to Find Your Handyman?
          </h3>
          <p className="text-lg mb-6 text-emerald-50">
            Get free quotes from multiple licensed handymen and compare their services.
          </p>
          <button className="px-8 py-4 bg-white text-emerald-600 font-semibold rounded-lg hover:bg-emerald-50 transition-colors whitespace-nowrap">
            Get Free Quotes Now
          </button>
        </div>
      </div>
    </section>
  );
}
